import _ from 'lodash';
import { useTranslation as useTranslationI18Next } from 'react-i18next';
import { isPlainTranslationInformation } from '../TranslationInformation';
export default function useTranslation() {
    var _a = useTranslationI18Next(), t = _a.t, i18n = _a.i18n;
    return {
        t: function (translationInformation, additionalParameters) {
            if (!translationInformation) {
                return '';
            }
            if (typeof translationInformation === 'string') {
                return t(translationInformation, additionalParameters);
            }
            if (typeof translationInformation === 'number') {
                return translationInformation.toString();
            }
            if (isPlainTranslationInformation(translationInformation)) {
                return translationInformation.plain;
            }
            if (_.isArray(translationInformation)) {
                translationInformation = {
                    key: translationInformation[0],
                    params: translationInformation[1]
                };
            }
            var mergedParameters = _.merge.apply(_, [translationInformation.params, additionalParameters]);
            return t(translationInformation.key, mergedParameters);
        },
        changeLanguage: function (languageCode, callback) {
            i18n.changeLanguage(languageCode, callback);
        }
    };
}
//# sourceMappingURL=UseTranslation.js.map